import type { MyBet } from '@ps/isp-web-services-types';
import { MultipleBetType } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Odds } from '@swf/sports/components';
import { getMultipleName } from '@swf/sports/utils/getMultipleName';

import { TXTWCL_Single } from './StakeHeader.messages.json';
import styles from './StakeHeader.scss';

export interface Props extends Pick<MyBet, 'betType' | 'odds' | 'numLines' | 'isSgm'> {
  isEachWay?: boolean;
}

const isMultipleBetType = (betType: string): betType is MultipleBetType =>
  Object.values(MultipleBetType).includes(betType as MultipleBetType);

const StakeHeader: React.FC<Props> = ({ betType, odds, isEachWay, numLines, isSgm }) => (
  <div className={styles.title}>
    <span>
      {!isMultipleBetType(betType) ? (
        <Translation {...TXTWCL_Single} />
      ) : (
        getMultipleName({
          betType,
          numberOfLines: numLines,
          isEachWay,
          isSgm
        })
      )}
    </span>
    <span>
      {odds && (
        <>
          {` `}@ <Odds {...odds} />
        </>
      )}
    </span>
  </div>
);

export default StakeHeader;
